import {concatPath, isNotEmpty} from "./CommonUtil";

export function img(path: string | null | undefined): string | undefined {
    if(isNotEmpty(path)) {
        // @ts-ignore
        return concatPath(getImageDownloadUrl(), path);
    } else {
        return undefined;
    }
}
export function getImageDownloadUrl(){
    // @ts-ignore
    return _IMAGE_DOWNLOAD_URL;
}

/**
 * 画像リサイズ用URLを取得
 */
// eslint-disable-next-line no-unused-vars
export function imgs(image_path: string | null | undefined, width: number, height: number) {
    if(image_path){
        const paramStr = image_path + "&w=" + width + "&h=" + height + "&op=";
        // eslint-disable-next-line no-undef
        // @ts-ignore
        return concatPath(_IMAGES_DOWNLOAD_URL, paramStr);
    }
    return undefined;
}

/**
 * 画像リサイズ(強制リサイズ（画像小さい場合でも拡大する）)用URLを取得
 */
export function imgsf(image_path: string, width: number, height: number) {
    let paramStr = image_path + "&w=" + width + "&h=" + height + "&op=";
    // eslint-disable-next-line no-undef
    // @ts-ignore
    return concatPath(_IMAGES_RESIZE_DOWNLOAD_URL, paramStr);
}